import React from 'react';

const NoAppIdComponent = () => {
  return (
    <>
      <h1>
        Unknown App Id. Nblocks don't know what app to serve.
      </h1>
      <h2>
        Go back to the app and retry
      </h2>
    </>
  )
}

export { NoAppIdComponent }
